import styled, { keyframes, css } from "styled-components";

// Shimmer animation keyframes
export const shimmerAnimation = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

// Base shimmer mixin as styled component
export const ShimmerBase = styled.div(
    ({ theme }) => css`
        //TODO: check with design around the correct color for this gradient
        background: linear-gradient(
            90deg,
            ${theme.colors[theme.colorMode].background_Secondary}15 0%,
            ${theme.colors[theme.colorMode].background_Secondary}05 52.08%,
            ${theme.colors[theme.colorMode].background_Secondary}15 100%
        );
        background-size: 1000px 100%;
        animation: ${shimmerAnimation} 2s infinite linear;
    `,
);

// Main shimmer container
export const ShimmerContainer = styled.div(({ theme }) => ({
    padding: `0px ${theme.spacing.medium}`,
}));

// Shimmer title
export const ShimmerTitle = styled(ShimmerBase)(({ theme }) => ({
    marginTop: theme.spacing.xxLarge,
    marginBottom: theme.spacing.medium,
    width: "80px",
    height: "15px",
    borderRadius: theme.cornerRadius.xxxSmall,
}));

// Shimmer ribbon
export const ShimmerRibbon = styled(ShimmerBase)(({ theme }) => ({
    position: "relative",
    borderRadius: `${theme.cornerRadius.medium} 0 0 ${theme.cornerRadius.medium}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50px",
}));

// Ribbon circles container
export const ShimmerRibbonCircles = styled.div(({ theme }) => ({
    position: "absolute",
    left: `calc(${theme.spacing.xxSmall} * -1)`,
    top: "30%",
}));

// Individual ribbon circle
export const ShimmerRibbonCircle = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.xSmall,
    background: theme.colors[theme.colorMode].canvas_Primary,
    borderRadius: "100%",
    width: "10px",
    height: "10px",
}));

// Main shimmer container card wrapper
export const ShimmerContainerWrapper = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    display: "flex",
    zIndex: 3,
    marginBottom: theme.spacing.large,
    width: "100%",
    height: "198px",
    borderRadius: theme.cornerRadius.medium,
}));

// Shimmer container card
export const ShimmerContainerCard = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    width: "100%",
    padding: `${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.small} ${theme.spacing.small}`,
    borderRadius: `0 ${theme.cornerRadius.medium} ${theme.cornerRadius.medium} 0`,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
}));

// Row 1 container
export const ShimmerContainerCardRow1 = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: theme.spacing.xSmall,
    height: "25px",
}));

// Logo and title container
export const ShimmerContainerCardRow1LogoAndTitle = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "calc(100% - 50px)",
});

// Row 1 Col 1 (logo)
export const ShimmerContainerCardRow1Col1 = styled(ShimmerBase)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    width: "20px",
    height: "20px",
    borderRadius: theme.cornerRadius.xSmall,
}));

// Row 1 Col 2 (title)
export const ShimmerContainerCardRow1Col2 = styled(ShimmerBase)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    width: "54px",
    height: "15px",
    marginLeft: theme.spacing.small,
    borderRadius: theme.cornerRadius.xxxSmall,
}));

// Row 1 Col 3 (right side)
export const ShimmerContainerCardRow1Col3 = styled(ShimmerBase)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    width: "44px",
    height: "17px",
    borderRadius: theme.cornerRadius.xxxSmall,
}));

// Separator line
export const ShimmerContainerCardSeparator = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    height: "1px",
}));

// Row 2
export const ShimmerContainerCardRow2 = styled(ShimmerBase)(({ theme }) => ({
    width: "172px",
    height: "17px",
    marginBottom: theme.spacing.small,
    borderRadius: theme.cornerRadius.xxxSmall,
    background: theme.colors[theme.colorMode].background_Secondary,
}));

// Row 3
export const ShimmerContainerCardRow3 = styled(ShimmerBase)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    width: "210px",
    height: "18px",
    marginTop: theme.spacing.small,
    borderRadius: theme.cornerRadius.xxxSmall,
}));

// Row 4
export const ShimmerContainerCardRow4 = styled(ShimmerBase)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    width: "210px",
    height: "18px",
    marginTop: theme.spacing.small,
    borderRadius: theme.cornerRadius.xxxSmall,
}));

// Row 5
export const ShimmerContainerCardRow5 = styled(ShimmerBase)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    width: "40px",
    height: "15px",
    marginTop: theme.spacing.medium,
    borderRadius: theme.cornerRadius.xxxSmall,
}));
